import {field} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";

export class BatchTransferReportData extends ReportData<BatchTransferReportData> {
    @field transferId: number;
}
